var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification hoverable clickable",on:{"click":_vm.emitClick}},[_c('v-icon',[_vm._v("mdi-bell")]),_c('div',{staticClass:"text"},[_vm._t("default",[_vm._v("У вас 1 непрочитанное уведомление")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }